import type { CampaignStatus } from '@/api/campaigns/types';

/**
 * Which status-change row actions are valid for a campaign in its current
 * status (quantix-api/docs/campaigns/TASKS.md: statuses are
 * draft/active/paused/archived; archived is terminal, delete is handled
 * separately by the API's zero-non-test-submissions rule).
 */
export interface CampaignStatusActions {
    canActivate: boolean;
    canPause: boolean;
    canArchive: boolean;
}

export function getCampaignStatusActions(status: CampaignStatus): CampaignStatusActions {
    switch (status) {
        case 'draft':
            return { canActivate: true, canPause: false, canArchive: true };
        case 'active':
            return { canActivate: false, canPause: true, canArchive: true };
        case 'paused':
            return { canActivate: true, canPause: false, canArchive: true };
        case 'archived':
            return { canActivate: false, canPause: false, canArchive: false };
        default:
            return { canActivate: false, canPause: false, canArchive: false };
    }
}
